'use client'
import { alpha } from '@mui/system/colorManipulator';
import { common } from '@mui/material/colors';
import { error, info, neutral, success, warning } from '../colors';
import { getPrimary } from '../utils';
import { createBrandColor } from "@theme/shared/create-brand-color";

export const createPalette = (config) => {
  const { colorPreset, contrast, branding } = config;

  // Tenant branding. `adminPrimary` → palette.primary, `adminSecondary` →
  // palette.secondary (a full MUI colour) and the legacy `brand2` accent string.
  // Both fall back to the built-in admin defaults.
  const adminPrimary = createBrandColor(branding?.adminPrimary);
  const adminSecondary =
    createBrandColor(branding?.adminSecondary) ?? createBrandColor(neutral[800]);
  // Feature-bar (side-nav) text colours — item text and the active item text.
  const navText = createBrandColor(branding?.adminNavText)?.main ?? neutral[400];
  const navActiveText =
    createBrandColor(branding?.adminNavActiveText)?.main ?? common.white;

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: contrast === 'high' ? neutral[50] : common.white,
      paper: common.white,
    },
    brand: "#E17000",
    brand2: adminSecondary.main,
    // Text/icon variants of brand/brand2. Light mode uses the tenant colour as
    // chosen; only dark mode adjusts it for readability.
    brandText: "#E17000",
    brand2Text: adminSecondary.main,
    divider: '#F2F4F7',
    error,
    info,
    mode: 'light',
    neutral,
    primary: adminPrimary ?? getPrimary(colorPreset),
    secondary: adminSecondary,
    navText,
    navActiveText,
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
    warning,
  };
};
